(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.section-resource-list__grid-toggle-btn');
    if (!button) return;

    const group = button.closest('.section-resource-list__grid-toggle');
    if (!group) return;

    group.querySelectorAll('.section-resource-list__grid-toggle-btn').forEach((btn) => {
      const isActive = btn === button;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const columns = button.dataset.columns;
    const section = button.closest('[data-testid="product-list"]');
    if (!section) return;

    // Try the documented test-id hook first, fall back to a guessed class name.
    const grid =
      section.querySelector('[data-testid="resource-list-grid"]') || section.querySelector('.resource-list');
    if (!grid) return;

    section.style.setProperty('--product-list-columns', columns);
    grid.style.setProperty('--columns', columns);
    grid.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
  });

  } catch(e) { console.error(e); }
})();
})();
